<template>
  <label class="text-reader">
    Somente arquivos .csv separados por ";"
    <br>
    <input type="file" @change="loadTextFromFile" accept=".csv">
  </label>
</template>

<script>
export default {
  methods: {
    loadTextFromFile(ev) {
      const file = ev.target.files[0]
      const reader = new FileReader()

      reader.onload = e => this.$emit('load', e.target.result)
      reader.readAsText(file)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// TextReader.vue?4b180a93